import { jsx } from "react/jsx-runtime";
import { memo, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { FormHelperText } from "@mui/material";
import { combinedFields } from "../../utils/yup/main.js";
import { Translate } from "../translate/translate.js";
import "yup";
import "../../utils/fields/personalInformation.js";
import "../../../../../type/Appointment.js";
import "../masked-date-input/masked-date-input.js";
import "react-text-mask";
import "../../utils/entities/Form.js";
import "../../../ana-toolbox/ana-toolbox.js";
import "../../../../../constants/date/date.js";
import "date-fns/fp/format";
import "date-fns/isValid";
import "date-fns/parse";
import "date-fns";
import "../../utils/helpers/toBoolean.js";
import "../../utils/helpers/createFields.js";
import "../../utils/helpers/resetFields.js";
import "../../utils/yup/yup.js";
import "../../../../../utils/pipe.js";
import "date-fns/fp";
import "libphonenumber-js/max";
import "libphonenumber-js/mobile";
import "../../utils/helpers/predicates.js";
import "../../utils/yup/emailValidation.js";
import "../../utils/fields/contactDetails.js";
import "../../utils/helpers/featureFlags.js";
import "../../utils/helpers/getAgeFromBirthday.js";
import "../../utils/yup/buildValidationSchema.js";
import "../../utils/fields/miscellaneous.js";
import "../../utils/fields/insurance.js";
import "../../utils/fields/allergiesAndMedications.js";
import "../../../../../type/Disease.js";
import "../../utils/config/medicaments.js";
import "../../utils/fields/wishesAndExpectations.js";
import "../../utils/fields/consents.js";
import "../../utils/fields/profileInterest.js";
const fieldsByName = Object.fromEntries(Object.values(combinedFields).map((field) => [field.name, field]));
const FieldHelperText = memo(({ name, helperData, error, helperText, className }) => {
  const { t } = useTranslation();
  const settings = fieldsByName[name];
  const content = useMemo(() => {
    if (error) {
      const fieldName = t(typeof (settings == null ? void 0 : settings.label) === "string" ? settings.label || name : name);
      const isEdgeCase = Array.isArray(fieldName) && !!fieldName.find((field) => typeof field !== "string");
      const fallbackError = t("generic_form_error", {
        // In cases where the translation contains JSX elements and we try to render it,
        // there will be an error like: 'Some text ,[object Object],' to avoid this, we use
        // another mechanism for receiving the translations: t(`${name}_form_error`)
        fieldName: isEdgeCase ? t(`${name.toLocaleLowerCase()}_form_error`) : fieldName,
        postProcess: []
      });
      return /* @__PURE__ */ jsx(Translate, { fallback: fallbackError, fieldName, children: error });
    }
    if (helperText)
      return /* @__PURE__ */ jsx(Translate, { ...helperData, options: { postProcess: "markdown" }, children: helperText });
    if (settings == null ? void 0 : settings.justificativeTooltipText) {
      return /* @__PURE__ */ jsx(Translate, { children: settings == null ? void 0 : settings.justificativeTooltipText });
    }
    return null;
  }, [name, helperText, helperData, settings == null ? void 0 : settings.justificativeTooltipText, settings == null ? void 0 : settings.label, t, error]);
  return /* @__PURE__ */ jsx(FormHelperText, { className, error: Boolean(error), hidden: !content, children: content });
});
export {
  FieldHelperText
};
